import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Typography, Container, useTheme } from "@mui/material";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import PodcastsRoundedIcon from "@mui/icons-material/PodcastsRounded";
import TheaterComedyRoundedIcon from "@mui/icons-material/TheaterComedyRounded";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { useAuth } from "../context/authContext";
import LogoLargeLight from "../assets/LogoLargeLight.svg";
import LogoLargeDark from "../assets/LogoLargeDark.svg";

export default function PollPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const interest = params.get("interest");
  const { user, login } = useAuth();
  const theme = useTheme();

  const iconMap = {
    books: <MenuBookRoundedIcon fontSize="inherit" />,
    podcasts: <PodcastsRoundedIcon fontSize="inherit" />,
    theatre: <TheaterComedyRoundedIcon fontSize="inherit" />,
    games: <SportsEsportsIcon fontSize="inherit" />,
    youtube: <YouTubeIcon fontSize="inherit" />,
    other: <CheckCircleIcon fontSize="inherit" />,
  };

  const interestIcon = iconMap[interest.toLowerCase()] || (
    <CheckCircleIcon fontSize="inherit" />
  );

  const handleBetaClick = () => {
    if (user) {
      navigate(`/track/u/${user.username}`);
    } else login();
  };

  return (
    <Container maxWidth="sm" sx={{ textAlign: "center", mt: 5 }}>
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <Box color="tertiary.main" fontSize={80} lineHeight={1}>
          {interestIcon}
        </Box>
        <Typography variant="h4" fontWeight="bold">
          Noted!
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ textWrap: "balance" }}
        >
          Thanks for sharing your preference, we'll let you know as soon as it's
          ready
        </Typography>
        <Box display="flex" gap={2} mt={2}>
          <Button variant="contained" onClick={handleBetaClick}>
            Explore beta now
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate("/?redirect=false")}
          >
            Visit homepage
          </Button>
        </Box>
        <Box sx={{ width: "170px", mt: 3 }}>
          <img
            src={theme.palette.mode === "dark" ? LogoLargeDark : LogoLargeLight}
            alt="Curate Logo"
            width="100%"
            // style={{ marginTop: 100 }}
          />
        </Box>
      </Box>
    </Container>
  );
}
